<template>
  <div class="phone-wrapper">
    <div class="phone-wrapper__content">
      <slot></slot>
    </div>
    <svg class="phone-wrapper__mask" width="0" height="0">
      <clipPath id="contentMask" clipPathUnits="objectBoundingBox">
        <path
          d="M 0.1094 0 C 0.0492 0 0 0.0228 0 0.0506 V 0.9464 C 0 0.9741 0.0492 0.9969 0.1094 0.9969 H 0.8908 C 0.9511 0.9969 0.9998 0.9743 0.9998 0.9464 V 0.0506 C 0.9998 0.0228 0.9511 0.0001 0.8908 0.0001 H 0.1094 Z"
        ></path>
      </clipPath>
    </svg>
    <svg
      class="phone-wrapper__border"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 365 735"
      style="enable-background: new 0 0 365 735; fill: white"
      preserveAspectRatio="none"
    >
      <g style="fill: transparent">
        <path
          d="M3 294.9V50.1C3 22.5 25.5 0 53.1 0H0v735h53.1C25.5 735 3 712.5 3 684.9v-390zM310.4 0c27.5 0 50.1 22.5 50.1 50.1V685c0 27.5-22.5 50.1-50.1 50.1H365V0h-54.6z"
        />
      </g>
      <g>
        <path
          d="M53.1 734.5c-27.3 0-49.6-22.2-49.6-49.6V294.4h-3v-54.1h3v-17h-3v-54.1h3v-26h-3v-27h3V50.1C3.5 22.8 25.7.5 53.1.5h257.4c27.3 0 49.6 22.2 49.6 49.6v138.2h4.5v87.1H360V685c0 27.3-22.2 49.6-49.6 49.6H53.1zM54.6 17C35 17 19 33 19 52.6v629.9C19 702 35 718 54.6 718h254.3c19.6 0 35.5-15.9 35.5-35.5V52.6c0-19.6-15.9-35.5-35.5-35.5H54.6z"
        />
        <path
          style="stroke: black"
          d="M310.4 1c27.1 0 49.1 22 49.1 49.1v138.7h4.5v86.1h-4.5V685c0 27.1-22 49.1-49.1 49.1H53.1C26 734 4 712 4 684.9v-391H1v-53.1h3v-18H1v-53.1h3v-27H1v-26h3V50.1C4 23 26 1 53.1 1h257.3M54.6 718.5H309c9.6 0 18.6-3.8 25.4-10.6 6.8-6.8 10.6-15.9 10.6-25.4V52.6c0-9.6-3.8-18.6-10.6-25.4-6.8-6.8-15.9-10.6-25.4-10.6H54.6c-9.6 0-18.6 3.8-25.4 10.6C22.3 34 18.5 43 18.5 52.6v629.9c0 9.6 3.8 18.6 10.6 25.4 6.9 6.8 15.9 10.6 25.5 10.6M310.4 0H53.1C25.5 0 3 22.5 3 50.1v65.6H0v28h3v25H0v55.1h3v16H0v55.1h3v390C3 712.5 25.5 735 53.1 735h257.4c27.5 0 50.1-22.5 50.1-50.1v-409h4.5v-88.1h-4.5V50.1C360.5 22.5 338 0 310.4 0zM54.6 717.5c-19.2 0-35-15.8-35-35V52.6c0-19.2 15.8-35 35-35h254.3c19.2 0 35 15.8 35 35v629.9c0 19.2-15.8 35-35 35H54.6z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PhoneWrapper',
}
</script>

<style lang="postcss">
.phone-wrapper {
  --dotcom-app-screens-width: 196px;
  --dotcom-app-screens-height: 387px;

  display: inline-block;
  position: relative;
  width: var(--dotcom-app-screens-width);
  height: var(--dotcom-app-screens-height);

  .phone-wrapper__content {
    clip-path: url(#contentMask);
    display: block;
    width: 175px;
    height: 370px;
    transform: translate(10px, 9px);
    overflow: hidden;
  }
}

.phone-wrapper__mask {
  position: absolute;
  pointer-events: none;
}

.phone-wrapper__border {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--dotcom-app-screens-width);
  height: var(--dotcom-app-screens-height);
  pointer-events: none;
}

@media (--md) {
  .phone-wrapper {
    --dotcom-app-screens-width: 325px;
    --dotcom-app-screens-height: 627px;
    --dotcom-app__content-wrapper-width: 290px;
    --dotcom-app__content-wrapper-height: 605px;
    .phone-wrapper__content {
      width: 290px;
      height: 600px;
      transform: translate(17px, 14px);
    }
  }
}
</style>
